import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

@Index('idx_list_user_tabs_unique', ['fkUserId', 'listKey'], { unique: true })
@Index('idx_list_user_tabs_user', ['fkUserId'])
@Entity('list_user_tabs')
export class ListUserTabsEntity extends BaseEntity {
	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('varchar', { name: '_list_key', length: 100 })
	public listKey!: string;

	@Column('json', { name: '_tab_ids' })
	public tabIds!: Array<string>;

	@Column('tinyint', { name: 'isEnabled', width: 1, default: () => "'1'" })
	public isEnabled!: boolean;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity | null;
}
